var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYahooLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yahoo-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Yahoo_x21_",
    d: "M20.138 89.731c-.612.165-6.209 4.505-6.578 5.57a41.834 41.834 0 0 0 .09 4.47c.369.082 3.031.011 3.52.092l-.059 1.1c-.479-.037-3.862-.028-5.792-.028-.981 0-4.135.108-5.1.08l.183-1.05c.532-.039 2.731.1 3.213-.416a18.141 18.141 0 0 0 .083-4.219A57.71 57.71 0 0 0 3.3 87.568H0v-1.545h11.141v.107a.248.248 0 0 1 .038 0l-.038.261v1.174H7.782c1.5 2.19 3.644 4.833 4.56 6.1l4.487-4.065h-2.667l-.376-1.543h9.771l-.072.11h.034l-.7 1.012h-.022l-.282.416h-1.8c-.233.061-.439.105-.577.136zm3.188 9.676l-.863-.043-.962-.117.008 1.65.759.065.818.06zM25 91.521c-.291-.01-2.938-.261-3.282-.329l.041 6.97 1.5.121z",
    className: "cls-1",
    transform: "translate(0 -86.023)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahooLogo);
export default __webpack_public_path__ + "static/media/yahoo-logo.5a7005954be209019f4097774458fef6.svg";
export { ForwardRef as ReactComponent };